// extracted by mini-css-extract-plugin
module.exports =  {"keywordBlock":"keywordBlock__ADGo-","keywordDesc":"keywordDesc__ak4hd"};